import React from "react";
import { Link } from "react-router-dom";

const Estoque = () => {
  return (
    <div>
      <Link to="/">GO TO HOME</Link>
    </div>
  );
};

export default Estoque;
